import { ColorDark } from '@superdispatch/ui';
import { TrialClockIcon } from 'shared/icons/TrialClockIcon';
import styled from 'styled-components';

const Container = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 8px;
  margin: 8px;
  background-color: #33200a;
  border-radius: 8px;
  text-decoration: none;
`;

const TrialText = styled.span`
  color: ${ColorDark.Yellow500};
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
  text-align: center;
`;

/** Sidebar is always dark, so the icon is pinned to the dark theme yellow. */
const StyledIcon = styled(TrialClockIcon)`
  margin-top: -24px;
  margin-bottom: 4px;
  font-size: 32px;

  path {
    fill: ${ColorDark.Yellow500};
  }
`;

export function SidebarTrialStatus() {
  return (
    <Container href="/tms/settings/subscription/?utm_medium=sidebar">
      <StyledIcon />
      <TrialText>Trial Expiring</TrialText>
    </Container>
  );
}
